import { createConsoleNotifier } from "./consoleNotifier";
import { IErrorNotifier } from "./types";

function createErrorNotifier(): IErrorNotifier {
  return createConsoleNotifier();
}

export { createErrorNotifier, type IErrorNotifier };
